import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "@Styles/mandate.css";
import Heading from "../Common/MainHeading";
import { HEADING_BLANK } from "../Common/constant";
// import disbursesuccess from "@Images/NewUI/disbursesuccess.png";
import DisbersedSuccess from "@Images/NewUI/disbursed.gif";

const DisburseSuccess = (props) => {
  const navigate = useNavigate();
  // console.log("propssssssss", props);
  const [amount, setAmount] = useState(props?.location?.state?.amount);

  useEffect(()=>{
     setTimeout(()=>{
       navigate("/dashboard_s")
     },3000)
  },[])
  return (
    <div id="background"  className="main_div">
      <div className="container aligncentre">
        <div className="pb-4">
          <Heading headingText={HEADING_BLANK} path="/dashboard_s" {...props}/>
          <div className="wrapper-content e-sign">
            <div className=" px-4 pb-3 pt-1 w-100 text-center mx-auto bg-gray rounded-40 shadow-lg">
              <div className="h-100 d-flex flex-column justify-content-between">
                <div className="pt-4 pb-5">
                  <img
                    src={DisbersedSuccess}
                    alt="disbursesuccess"
                    style={{ maxWidth: "100%", margin: "0px 0px" }}
                  />
                  <p 
                  style={{fontSize:"32px", fontWeight:"700", color:"#152745"}}
                  >
                  Amount Successfully Disbursed
                  </p>
                  <p
                    style={{
                      fontSize: "56px",
                      fontWeight: "500",
                      color: "rgba(252, 102, 3, 1)",
                    }}
                  >
                    ₹ {amount||0}
                   
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <button
              className="newbtnDesignmodal"
              onClick={() => {
                navigate("/super-loan-dashboard");
              }}
            >
              Back to Home
        </button>
      </div>      
    </div>
  );
};

export default DisburseSuccess;
